import { itemFields } from 'src/enums/time-tracker';
import { getVisibleFields } from 'src/common/table/column-utils';

export type TTimeTrackerField = (typeof fieldMap)[number];

const fieldMap = Object.values(itemFields);
export const getFields = (disabledFields: string[] = []) => getVisibleFields(fieldMap, disabledFields);
